<div class="border border-1 border p-4 mb-4">
  <div class="d-flex justify-content-between align-items-center">
    <mat-form-field appearance="fill">
      <mat-label>Utilisateur</mat-label>
      <input matInput placeholder="Utilisateur" [(ngModel)]="user" />
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Client</mat-label>
      <input matInput placeholder="Client" [(ngModel)]="client" />
    </mat-form-field>

    <mat-form-field>
      <mat-label>Type de recherche</mat-label>
      <mat-select>
        <mat-option
          *ngFor="let requestType of requestTypes"
          [value]="requestType"
        >
          {{ requestType }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
      <mat-label>Dates de recherche</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate placeholder="Date de début" />
        <input matEndDate placeholder="Date de fin" />
      </mat-date-range-input>
      <mat-hint>Date de début – Date de fin</mat-hint>
      <mat-datepicker-toggle
        matIconSuffix
        [for]="picker"
      ></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>
  </div>

  <div class="d-flex justify-content-end mt-3">
    <button mat-button class="me-3">Réinitialiser les filtres</button>
    <button mat-raised-button color="primary" class="me-3">Rechercher</button>
    <button mat-raised-button color="accent">Exporter</button>
  </div>
</div>
